import { userService } from "../services/user.service.js"
import { store } from '../store/store.js'

// import { showErrorMsg } from '../services/event-bus.service.js'
import { LOADING_DONE, LOADING_START } from "./system.reducer.js";
import { REMOVE_USER, SET_USER, SET_USERS, SET_WATCHED_USER } from "./user.reducer.js";



export async function CargarUsers(id_region) {
    try {
        store.dispatch({ type: LOADING_START });
        const users = await userService.getUsusarios(id_region);
        store.dispatch({ type: SET_USERS, users });
    } catch (err) {
        console.log('UserActions: err in loadUsers', err)
    } finally {
        store.dispatch({ type: LOADING_DONE })
    }
}

// Funcion para guardar usuarios nuevos
export async function AddUsers(datauser) {
    try {
        // Recupera el estado actual de los usuarios
        const { users } = store.getState().userModule;
        
        // Envía la solicitud para guardar el nuevo usuario en la base de datos
        const newUser = await userService.GuardarUsuario(datauser);
        
        // Agrega el nuevo usuario al array de usuarios
        const updatedUsers = [...users, newUser];
        
        // Despacha la acción para establecer los usuarios actualizados en el estado
        store.dispatch({ type: SET_USERS, users: updatedUsers });
        return newUser;
    } catch (err) {
        console.log('UserActions: error en AddUsers', err);
    }
}


//Funcion para actualizar usuarios
// export async function updateUsers(datauser) {
//     try {
//         // Recupera el estado actual de los usuarios
//         const { users } = store.getState().userModule;
//         console.log("Usuario sin actualizar ",datauser);
//         // Envía la solicitud para actualizar los datos del usuario
//         const updatedUser = await userService.actualizardatosUsuario(datauser);
//         console.log("Usuario actualizado ",updatedUser);
        
//         // Actualiza los datos del usuario en el array users
//         const updatedUsers = users.map(user => 
//             user.id_usuario === datauser.id_usuario ? datauser : user
//         );
        
//         // Despacha la acción para establecer los usuarios actualizados en el estado
//         store.dispatch({ type: SET_USERS, users: updatedUsers });
//     } catch (err) {
//         console.log('UserActions: err in updateUsers', err);
//     }
// }

export async function updateUsers(datauser) {
    try {
        // Recupera el estado actual de los usuarios
        const { users } = store.getState().userModule;
       
        
        // Envía la solicitud para actualizar los datos del usuario
        const updatedUser = await userService.actualizardatosUsuario(datauser);
        
        // Eliminar el campo password_hash del datauser antes de enviarlo al store
        const usercopia = { ...datauser };
        delete usercopia.password_hash;
       
        
        // Actualiza los datos del usuario en el array users
        const updatedUsers = users.map(user => 
            user.id_usuario === datauser.id_usuario ? usercopia : user
        );
        
        // Despacha la acción para establecer los usuarios actualizados en el estado
        store.dispatch({ type: SET_USERS, users: updatedUsers });
    } catch (err) {
        console.log('UserActions: err in updateUsers', err);
    }
}


//FUNCION PARA ACTUALIZAR EL ROL DEL USUARIO

export async function updateRolUsers(dusuarios, dataRol) {
    try {
       
        
        // Recupera el estado actual de los usuarios
        const { users } = store.getState().userModule;
        
        // Envía la solicitud para actualizar los datos del usuario
        const updatedRolUser = await userService.UpdateRolUsers(dataRol);
        
        // Actualiza los datos del usuario en el array users
        const datauser = users.map(user => 
            user.id_usuario === dusuarios.id_usuario ? dusuarios : user
        );
        
        // Despacha la acción para establecer los usuarios actualizados en el estado
        store.dispatch({ type: SET_USERS, users: datauser });
    } catch (err) {
        console.log('UserActions: err in updateUsers', err);
    }
}

// export async function handleResponsable(responsable, mode) {
//     const { users } = store.getState().userModule;
   
//     try {
      
//         switch (mode) {
//             case "ADD":
//                 const ResponUser  =  await userService.updateResponsables(responsable, "guardar");
//                 console.log("lo que retorna la api responable ",ValorRetornado);

//                 break;
//             case "REMOVE":
//                 await userService.updateResponsables(responsable, "eliminar");


//                 break;
//         }

       
//     } catch (err) {
//         console.log('UserActions: error in updateUsers', err);
//     } 
// }


export async function handleResponsable(responsable, mode) {
    const { users } = store.getState().userModule;
   

    try {
        switch (mode) {
            case "ADD":
                // Hacer la solicitud a la API para agregar la responsabilidad
                const ResponUser = await userService.updateResponsables(responsable, "guardar");
                

                // Encontrar el usuario correspondiente en el estado de users
                const updatedUsers = users.map(user => {
                    if (user.id_usuario === ResponUser.fk_usuario_id) {
                        // Actualizar el array de responsabilidades del usuario
                        return {
                            ...user,
                            responsable: [...user.responsable, ResponUser]
                        };
                    }
                    return user;
                });

                // Despachar la acción para actualizar el estado de users en el reducer
                store.dispatch({ type: SET_USERS, users: updatedUsers });
           
                break;

                case "REMOVE":
                    // Aquí podrías implementar la lógica para eliminar la responsabilidad
                
                    // Hacer la solicitud a la API para eliminar la responsabilidad
                    await userService.updateResponsables(responsable, "eliminar");
                
                    // Actualizar el estado después de la eliminación
                    console.log("datos del responsable:", responsable);
                    
                    const updatedUsersAfterRemoval = users.map(user => {
                        if (user.id_usuario === responsable.fk_usuario_id) {
                            // Filtrar la responsabilidad a eliminar basándose en fk_actividad_id o fk_subactividad_id
                            const updatedResponsable = user.responsable.filter(res => {
                                // Verificar si se debe eliminar por fk_actividad_id o fk_subactividad_id
                                const removeByActivity = responsable.fk_actividad_id && res.fk_actividad_id === responsable.fk_actividad_id;
                                const removeBySubactivity = responsable.fk_subactividad_id && res.fk_subactividad_id === responsable.fk_subactividad_id;
                                
                                return !(removeByActivity || removeBySubactivity);
                            });
                            
                            return {
                                ...user,
                                responsable: updatedResponsable
                            };
                        }
                        return user;
                    });
                
                    // Verificar el estado antes de actualizar el store
                    console.log("Estado actualizado de usuarios después de eliminación:", updatedUsersAfterRemoval);
                
                    // Despachar la acción para actualizar el estado de users en el reducer
                    store.dispatch({ type: SET_USERS, users: updatedUsersAfterRemoval });
                    break;
                

            default:
                break;
        }
    } catch (err) {
        console.log('UserActions: error in updateUsers', err);
    }
}

export async function loadUsers() {
    try {
        store.dispatch({ type: LOADING_START })
        const users = await userService.getUsers()
        store.dispatch({ type: SET_USERS, users })
    } catch (err) {
        console.log('UserActions: err in loadUsers', err)
    } finally {
        store.dispatch({ type: LOADING_DONE })
    }
}

// TODO:REMOVE THIS
export async function removeUser(userId) {
    try {
        await userService.remove(userId)
        store.dispatch({ type: REMOVE_USER, userId })
    } catch (err) {
        console.log('UserActions: err in removeUser', err)
    }
}


//login para validar datos usuario

export async function login(credentials) {
    try {
        const user = await userService.login(credentials);
        store.dispatch({
            type: SET_USER,
            user
        });
       
        return { success: true };
    } catch (err) {
        // console.log('UserActions: err in login', err);
        return { success: false, error: err.message };
    }
}


// export async function login(credentials) {
//     try {
//         const result = await userService.login(credentials);
//         if (result.success === true) {
//             store.dispatch({
//                 type: SET_USER,
//                 user: result.user
//             });
//             return result;
//         } else {
//             return { success: false };
//         }
//     } catch (err) {
//         return { success: false, error: err };
//     }
// }

export async function signup(credentials) {
    try {
        const user = await userService.signup(credentials)
        store.dispatch({
            type: SET_USER,
            user
        })
        return user
    } catch (err) {
        console.log('Cannot signup', err)
        throw err
    }
}

export async function logout() {
    try {
        await userService.logout()
        store.dispatch({
            type: SET_USER,
            user: null
        })
        clearUsers();
    } catch (err) {
        console.log('Cannot logout', err)
        throw err
    }
}

//Limpiar lista de usuarios 
export async function clearUsers() {
    try {
        // Aquí puedes agregar cualquier operación asíncrona en el futuro si es necesario
        store.dispatch({ type: SET_USERS, users: [] })
    } catch (err) {
        console.log('Cannot clear users', err)
        throw err
    }
}


export async function loadUser(userId) {
    try {
        const user = await userService.getById(userId);
        store.dispatch({ type: SET_WATCHED_USER, user })
    } catch (err) {
        // showErrorMsg('Cannot load user')
        console.log('Cannot load user', err)
    }
}